const DEFAULT_COUNTS = { audio: 0, images: 0, videos: 0 };

export const PROJECT_STAGES = {
  'needs-audio': {
    id: 'needs-audio',
    label: 'Needs Voice',
    accent: '#f97316',
    nextAction: 'Generate Voice',
    description: 'Add a voiceover to unlock imagery + video automation.'
  },
  'needs-image': {
    id: 'needs-image',
    label: 'Needs Visuals',
    accent: '#f59e0b',
    nextAction: 'Generate Image',
    description: 'Create visuals to pair with your best audio take.'
  },
  'needs-video': {
    id: 'needs-video',
    label: 'Needs Video',
    accent: '#38bdf8',
    nextAction: 'Generate Video',
    description: 'You have voice + visual assets—combine them into video.'
  },
  ready: {
    id: 'ready',
    label: 'Ready to Publish',
    accent: '#10b981',
    nextAction: 'Open Project',
    description: 'Video assets are ready. Review and export.'
  }
};

export function getProjectCounts(project) {
  if (!project || typeof project !== 'object') return { ...DEFAULT_COUNTS };
  const counts = project.counts || {};
  return {
    audio: Number.isFinite(Number(counts.audio))
      ? Number(counts.audio)
      : Number(counts.voices || 0),
    images: Number.isFinite(Number(counts.images)) ? Number(counts.images) : 0,
    videos: Number.isFinite(Number(counts.videos)) ? Number(counts.videos) : 0
  };
}

export function getProjectStage(project) {
  const counts = getProjectCounts(project);
  let stage = PROJECT_STAGES['needs-audio'];

  if (counts.videos > 0) stage = PROJECT_STAGES.ready;
  else if (counts.audio > 0 && counts.images > 0) stage = PROJECT_STAGES['needs-video'];
  else if (counts.audio > 0) stage = PROJECT_STAGES['needs-image'];

  return { ...stage, counts };
}
